module.exports = __webpack_public_path__ + "static/media/SuccessStory.fb93eb37.png";